module.exports = __webpack_public_path__ + "static/media/ic_selectArrowDown.77769591.svg";